"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewItemListEvent = void 0;
const abstract_sales_event_1 = require("./abstract-sales.event");
class ViewItemListEvent extends abstract_sales_event_1.AbstractSalesEvent {
    constructor(config) {
        super(config);
        this.config = config;
        this.name = 'view_item_list';
    }
    getData() {
        return {
            listId: this.config.listId,
            listName: this.config.listName,
            items: Array.isArray(this.config.items) ? this.config.items.map(item => (Object.assign({}, item))) : [],
        };
    }
}
exports.ViewItemListEvent = ViewItemListEvent;
//# sourceMappingURL=view-item-list.event.js.map